module.exports = __webpack_public_path__ + "img/image1.52025ec1.png";